/**
 * Les 3 templates WIDE (composants forwardRef `{ data }`), instanciés depuis
 * `WideSheetView` + une palette du grand format — le layout wide réutilise
 * les mêmes 3 palettes que le grand format (`largePalettes.ts`), seule la
 * feuille change (paysage, N colonnes). Fichier « composants uniquement »
 * (contrat `MenuWideComponent`, cible `domToPng`).
 */
import { forwardRef } from "react";

import type { MenuWideData } from "../types";
import { WideSheetView } from "./WideSheet";
import { BOUDOIR_LARGE, EDITORIAL_LARGE, POP_LARGE } from "./largePalettes";

export const BoudoirWideTemplate = forwardRef<HTMLDivElement, { data: MenuWideData }>(
  function BoudoirWideTemplate({ data }, ref) {
    return <WideSheetView ref={ref} data={data} palette={BOUDOIR_LARGE} />;
  },
);

export const EditorialWideTemplate = forwardRef<HTMLDivElement, { data: MenuWideData }>(
  function EditorialWideTemplate({ data }, ref) {
    return <WideSheetView ref={ref} data={data} palette={EDITORIAL_LARGE} />;
  },
);

export const PopWideTemplate = forwardRef<HTMLDivElement, { data: MenuWideData }>(
  function PopWideTemplate({ data }, ref) {
    return <WideSheetView ref={ref} data={data} palette={POP_LARGE} />;
  },
);
